"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.noticeImageLoadError = exports.createItemLoadTimer = exports.monitorProjectSelected = exports.monitorStartWorkbookCreation = exports.monitorWorkbookCanceled = exports.monitorWorkbookCreated = exports.monitorSelectJumpstart = exports.monitorOpenJumpstartListAction = void 0;
var InteractionMonitoring_1 = require("./InteractionMonitoring");
var Monitoring_1 = require("./Monitoring");
/**
 * Wrapper on top of Monitoring.ts
 */
var ACTION_NAME_PREFIX = 'jumpstart';
var ACTION_NAME_SEPARATOR = '.';
var ACTION_NAME_OPEN_JUMPSTART_LIST = 'open';
var ACTION_NAME_SELECT_JUMPSTART = 'select';
var ACTION_NAME_PROJECT_SELECTED = 'project.selected';
var ACTION_NAME_START_CREATION = 'start.creation';
var ACTION_NAME_CREATED = 'created';
var ACTION_NAME_CANCELED = 'canceled';
function monitorOpenJumpstartListAction() {
    monitorPageActionWrapper(ACTION_NAME_OPEN_JUMPSTART_LIST);
}
exports.monitorOpenJumpstartListAction = monitorOpenJumpstartListAction;
function monitorSelectJumpstart(templateId, connectionType) {
    var attributes = { templateId: templateId, connectionType: connectionType };
    monitorPageActionWrapper(ACTION_NAME_SELECT_JUMPSTART, attributes);
}
exports.monitorSelectJumpstart = monitorSelectJumpstart;
function monitorWorkbookCreated(templateId, connectionType, success) {
    var attributes = {
        templateId: templateId,
        connectionType: connectionType,
        success: success.toString(),
    };
    monitorPageActionWrapper(ACTION_NAME_CREATED, attributes);
}
exports.monitorWorkbookCreated = monitorWorkbookCreated;
function monitorWorkbookCanceled(templateId, connectionType) {
    var attributes = { templateId: templateId, connectionType: connectionType };
    monitorPageActionWrapper(ACTION_NAME_CANCELED, attributes);
}
exports.monitorWorkbookCanceled = monitorWorkbookCanceled;
function monitorStartWorkbookCreation(templateId, connectionType, credentialId) {
    var attributes = {
        templateId: templateId,
        connectionType: connectionType,
        credentialId: credentialId,
    };
    monitorPageActionWrapper(ACTION_NAME_START_CREATION, attributes);
}
exports.monitorStartWorkbookCreation = monitorStartWorkbookCreation;
function monitorProjectSelected(templateId, projectId, workbookName) {
    var attributes = {
        templateId: templateId,
        projectId: projectId,
        workbookName: workbookName,
    };
    monitorPageActionWrapper(ACTION_NAME_PROJECT_SELECTED, attributes);
}
exports.monitorProjectSelected = monitorProjectSelected;
function createItemLoadTimer(position, templateId) {
    var eventName = buildMonitoringEventName('img.load.' + position.toString() + '.' + templateId);
    return InteractionMonitoring_1.InteractionMonitor.getInstance().createTracer(eventName);
}
exports.createItemLoadTimer = createItemLoadTimer;
function noticeImageLoadError(templateId, imageUrl) {
    (0, Monitoring_1.monitorError)('img.load.error.' + templateId + ' url:' + imageUrl);
}
exports.noticeImageLoadError = noticeImageLoadError;
function monitorPageActionWrapper(name, attributes) {
    (0, Monitoring_1.monitorPageAction)(buildMonitoringEventName(name), attributes);
}
function buildMonitoringEventName(name) {
    return ACTION_NAME_PREFIX + ACTION_NAME_SEPARATOR + name;
}
//# sourceMappingURL=TemplatesMonitoring.js.map